export default class Utils {
	//Számok formázása, ezres tördelésbe
	static formatNumber(number: number): string {
		return !isNaN(number) ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : number.toString();
	}

	//sort() függvény-hez dátum stringek összehasonlítása
	static compareDates(a: string, b: string, order: 'asc' | 'desc' = 'asc') {
		if (order === 'asc') {
			return new Date(a.replace(' ', 'T')).getTime() - new Date(b.replace(' ', 'T')).getTime();
		} else {
			return new Date(b.replace(' ', 'T')).getTime() - new Date(a.replace(' ', 'T')).getTime();
		}
	}

	//Dátum visszaadása YYYY-MM-DD formában
	static getDateString(date: string | Date) {
		if (typeof date === 'string') {
			date = new Date(date.replace(' ', 'T'));
		}
		return date.toLocaleDateString('hu-HU').replace(/\. /g, '-').replace(/\./g, '');
	}

	//Dátum visszaadása 'YYYY .MM .DD HH:ii formában
	static getFullDateTimeString(date: string | Date) {
		if (typeof date === 'string') {
			date = new Date(date.replace(' ', 'T'));
		}
		return date.toLocaleTimeString('hu', {
			year: 'numeric',
			month: '2-digit',
			day: '2-digit',
			hour: '2-digit',
			minute: '2-digit',
		});
	}

	//Adott dátumra visszaadja az adott heti hétfő dátumát
	static getMondayDate(date: Date) {
		const day = date.getDay();
		const diff = date.getDate() - day + (day === 0 ? -6 : 1);
		return new Date(date.setDate(diff));
	}

	//Adott dátumra visszaadja a hét kezdetének és végének dátumát
	static getWeekInterval = (date: Date) => {
		const weekStart = Utils.getMondayDate(date);
		let weekEnd = new Date(weekStart);
		weekEnd.setDate(weekEnd.getDate() + 6);
		return {
			weekStart,
			weekEnd,
		};
	};

	// Meghatározza adott dátumra, hogy hanyadik hétre esik
	static getWeekNumber(date: Date = new Date()) {
		var d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
		var dayNum = d.getUTCDay() || 7;
		d.setUTCDate(d.getUTCDate() + 4 - dayNum);
		var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
		return Math.ceil(((d.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
	}

	static isValidDate(date: any) {
		return date instanceof Date && !isNaN(date.getTime());
	}

	static isMobile() {
		return (
			navigator.userAgent.match(/Android/i) ||
			navigator.userAgent.match(/BlackBerry/i) ||
			[ 'iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
			// iPad on iOS 13 detection
			(navigator.userAgent.includes("Mac") && "ontouchend" in document) ||
			navigator.userAgent.match(/iPhone|iPad|iPod/i) ||
			navigator.userAgent.match(/Opera Mini/i) ||
			navigator.userAgent.match(/IEMobile/i) ||
			navigator.userAgent.match(/WPDesktop/i)
		);
	}
}
